import { render } from "./loginbanner.vue?vue&type=template&id=e1aa2d40"
import script from "./loginbanner.vue?vue&type=script&lang=js"
export * from "./loginbanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__